var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('quill-editor',{ref:"quillEditor",staticClass:"quill-editor-container",attrs:{"options":_vm.editorOptions},on:{"change":_vm.onEditorChange,"ready":_vm.onEditorReady},model:{value:(_vm.editorContent),callback:function ($$v) {_vm.editorContent=$$v},expression:"editorContent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }